// Steps/Education.js

import { useForm } from "react-hook-form";
import { useNavigate, Link } from "react-router-dom";
import { useAppState } from "../state";
import { Button, Field, Form, Input } from "../Forms/";
import {useEffect, useState, useMemo} from "react";

export const Data = () => {
    const [state, setState] = useAppState();
    const [value, setValue] = useState(false);
    const [enableInvoiceAddress, setInvoiceAddress] = useState(false);

    const {
        handleSubmit,
        register,
        formState: { errors },
    } = useForm({ mode: "onSubmit" });
    const navigate = useNavigate();

    const saveData = (data) => {
        setState({ ...state, ...data });
        navigate("/samenvatting");
    };

    function handleChange(evt) {
        const targetValue = evt.target.value;
        setValue({
            ...value,
            [evt.target.name]: targetValue
        });
    }

    function handleAddress(val) {
        setInvoiceAddress(val.target.checked)
    }

    return (
        <div className="checkout__form__step" data-form="2">
            <Form onSubmit={handleSubmit(saveData)}>
                <div className="row mt-3">
                    <div className="col-md-12">
                        <h5>Contactgegevens</h5>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 col-lg-6">
                        <Field label="Naam" error={errors?.name} className={value.name ? 'active': ''}>
                            <Input
                                {...register("name", { required: "Voornaam is verplicht", onChange: (e) => handleChange(e) })}
                                id="name"
                                placeholder='Naam'
                            />
                        </Field>
                    </div>
                    <div className="col-12 col-lg-6">
                        <Field label="Functie" error={errors?.function} className={value.function ? 'active': ''}>
                            <Input
                                {...register("function", { required: "Functie is verplicht", onChange: (e) => handleChange(e) })}
                                id="function"
                                placeholder='Functie'
                            />
                        </Field>
                    </div>
                    <div className="col-12 col-lg-6">
                        <Field label="Telefoon" error={errors?.phone} className={value.phone ? 'active': ''}>
                            <Input
                                {...register("phone", { required: "Telefoon is verplicht", onChange: (e) => handleChange(e) })}
                                id="phone"
                                placeholder='Telefoon'
                            />
                        </Field>
                    </div>
                    <div className="col-12 col-lg-6">
                        <Field label="E-mailadres" error={errors?.email} className={value.email ? 'active': ''}>
                            <Input
                                {...register("email", { required: "E-mailadres is verplicht", onChange: (e) => handleChange(e) })}
                                id="email"
                                placeholder='E-mailadres'
                            />
                        </Field>
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col-md-12">
                        <h5>Bedrijfsgegevens</h5>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <Field label="Bedrijfsnaam" error={errors?.companyName} className={value.companyName ? 'active': ''}>
                            <Input
                                {...register("companyName", { required: "Bedrijfsnaam is verplicht", onChange: (e) => handleChange(e) })}
                                id="companyName"
                                placeholder='Bedrijfsnaam'
                            />
                        </Field>
                    </div>
                    <div className="col-12 col-lg-8">
                        <Field label="Straatnaam" error={errors?.street} className={value.street ? 'active': ''}>
                            <Input
                                {...register("street", { required: "Straatnaam is verplicht", onChange: (e) => handleChange(e) })}
                                id="street"
                                placeholder='Straatnaam'
                            />
                        </Field>
                    </div>
                    <div className="col-12 col-lg-4">
                        <Field label="Huisnummer" error={errors?.houseNumber} className={value.houseNumber ? 'active': ''}>
                            <Input
                                {...register("houseNumber", { required: "Huisnummer is verplicht", onChange: (e) => handleChange(e) })}
                                id="houseNumber"
                                placeholder='Huisnummer'
                            />
                        </Field>
                    </div>
                    <div className="col-12 col-lg-6">
                        <Field label="Postcode" error={errors?.postalCode} className={value.postalCode ? 'active': ''}>
                            <Input
                                {...register("postalCode", { required: "Postcode is verplicht", onChange: (e) => handleChange(e) })}
                                id="postalCode"
                                placeholder='Postcode'
                            />
                        </Field>
                    </div>
                    <div className="col-12 col-lg-6">
                        <Field label="Plaats" error={errors?.city} className={value.city ? 'active': ''}>
                            <Input
                                {...register("city", { required: "Plaats is verplicht", onChange: (e) => handleChange(e) })}
                                id="city"
                                placeholder='Plaats'
                            />
                        </Field>
                    </div>
                    <div className="col-12 col-lg-6">
                        <Field label="Algemeen telefoonnummer" error={errors?.companyPhone} className={value.companyPhone ? 'active': ''}>
                            <Input
                                {...register("companyPhone", { required: "Telefoon is verplicht", onChange: (e) => handleChange(e) })}
                                id="companyPhone"
                                placeholder='Algemeen telefoonnummer'
                            />
                        </Field>
                    </div>
                    <div className="col-12 col-lg-6">
                        <Field label="Algemeen e-mailadres" error={errors?.companyEmail} className={value.companyEmail ? 'active': ''}>
                            <Input
                                {...register("companyEmail", { required: "E-mailadres is verplicht", onChange: (e) => handleChange(e) })}
                                id="companyEmail"
                                placeholder='Algemeen e-mailadres'
                            />
                        </Field>
                    </div>
                    <div className="col-12">
                        <Field label="Website" error={errors?.website} className={value.website ? 'active': ''}>
                            <Input
                                {...register("website", { required: "Website is verplicht", onChange: (e) => handleChange(e) })}
                                id="website"
                                placeholder='Website'
                            />
                        </Field>
                    </div>
                    <div className="col-12">
                        <Field label="Ik wil een afwijkend factuuradres opgeven" className="box__input">
                            <Input
                                {...register("invoiceAddress",{
                                    onChange: (e) => handleAddress(e)
                                })}
                                id="invoice_address" type='checkbox' value="1"
                            />
                        </Field>
                    </div>
                </div>
                {enableInvoiceAddress ?
                    <div className="row mt-2">
                        <div className="col-12">
                            <h5>Afwijkend factuuradres</h5>
                        </div>
                        <div className="col-12">
                            <Field label="Algemeen e-mailadres" error={errors?.invoiceEmail} className={value.invoiceEmail ? 'active': ''}>
                                <Input
                                    {...register("invoiceEmail", { required: "E-mailadres is verplicht", onChange: (e) => handleChange(e) })}
                                    id="invoiceEmail"
                                    placeholder='E-mailadres'
                                />
                            </Field>
                        </div>
                        <div className="col-12 col-lg-8">
                            <Field label="Straatnaam" error={errors?.invoiceStreet} className={value.invoiceStreet ? 'active': ''}>
                                <Input
                                    {...register("invoiceStreet", { required: "Straatnaam is verplicht", onChange: (e) => handleChange(e) })}
                                    id="invoiceStreet"
                                    placeholder='Straatnaam'
                                />
                            </Field>
                        </div>
                        <div className="col-12 col-lg-4">
                            <Field label="Huisnummer" error={errors?.invoiceHouseNumber} className={value.invoiceHouseNumber ? 'active': ''}>
                                <Input
                                    {...register("invoiceHouseNumber", { required: "Huisnummer is verplicht", onChange: (e) => handleChange(e) })}
                                    id="invoiceHouseNumber"
                                    placeholder='Huisnummer'
                                />
                            </Field>
                        </div>
                        <div className="col-12 col-lg-6">
                            <Field label="Postcode" error={errors?.invoicePostalCode} className={value.invoicePostalCode ? 'active': ''}>
                                <Input
                                    {...register("invoicePostalCode", { required: "Postcode is verplicht", onChange: (e) => handleChange(e) })}
                                    id="invoicePostalCode"
                                    placeholder='Postcode'
                                />
                            </Field>
                        </div>
                        <div className="col-12 col-lg-6">
                            <Field label="Plaats" error={errors?.invoiceCity} className={value.invoiceCity ? 'active': ''}>
                                <Input
                                    {...register("invoiceCity", { required: "Plaats is verplicht", onChange: (e) => handleChange(e) })}
                                    id="invoiceCity"
                                    placeholder='Plaats'
                                />
                            </Field>
                        </div>
                    </div>
                : ''}
                <div className="row mt-3">
                    <div className="col-md-12">
                        <h5>Bedrijfsactiviteit</h5>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <Field label="Branche" error={errors?.branche} className={value.branche ? 'active select' : 'select'}>
                            <select
                                name="branche"
                                id="branche"
                                {...register("branche", {
                                    required: "Kies een branche",
                                    onChange: (e) => handleChange(e)
                                })}
                            >
                                <option value='' disabled selected>Kies een branche</option>
                                {branches.map((branche) => (
                                    <option value={branche.id}>{branche.title}</option>
                                ))}
                            </select>
                        </Field>
                    </div>
                    <div className="col-12">
                        <Field label="Bedrijfsactiviteit" error={errors?.companyActivity} className={value.companyActivity ? 'active': ''}>
                            <Input
                                {...register("companyActivity", { required: "Bedrijfsactiviteit is verplicht", onChange: (e) => handleChange(e) })}
                                id="companyActivity"
                                placeholder='Bedrijfsactiviteit'
                            />
                        </Field>
                    </div>
                </div>
                <div className="checkout__form__actions d-flex align-items-center justify-content-between mt-4">
                    <Link to="/">
                        Vorige stap
                    </Link>
                    <Button>Volgende stap</Button>
                </div>
            </Form>
        </div>
    );
};
